export default __webpack_public_path__ + "static/media/Air.8f7d43b9.svg";